import React from "react";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";

const ProfileScreen = () => {
  const profile = useSelector((state) => state.profile);
  const history = useHistory();
  const routeChange = () => {
    let path = '/a7/twitter/edit_profile'
    history.push(path)
  }
  return(
      <div>

        <h4>
          <button className={"btn fas fa-arrow-left"}
             onClick={() => {history.goBack()}}></button>
          {profile.firstName} {profile.lastName}</h4>
        <h6 className={"text-secondary ms-5"}>{profile.tweets} Tweets</h6>
        <img style={{display: "flex"}}
             src={profile.bannerPicture}
             alt={"banner"}
             width="100%"
             height="200px"/>
        <img className="rounded-circle wd-avatar-image"
             style={{width: '144px', float: "top", marginTop: "-8%", position: "relative", zIndex: 1}}
             alt={"avatar"}
             src={profile.profilePicture}/>
        <div className = "btn btn-secondary rounded-pill float-end me-5 mt-3" onClick={routeChange}>
          Edit profile
        </div>
        <h4>{profile.firstName} {profile.lastName}</h4>
        <a href={'#top'} className={"text-secondary text-decoration-none"}>@{profile.handle}</a>

        <h6>{profile.bio}</h6>
        <li className="fas fa-map-marker-alt text-secondary"></li> <a href={'#top'} className={"text-secondary text-decoration-none"}>{profile.location}</a>
        <li className="fas fa-birthday-cake text-secondary ms-3"></li> <a href={'#top'} className={"text-secondary text-decoration-none"}>Born {profile.dateOfBirth}</a>
        <li className="fas fa-calendar-alt text-secondary ms-3"></li> <a href={'#top'} className={"text-secondary text-decoration-none"}>Joined {profile.dateJoined}</a>

        <div>
          <a href={'#top'} className="text-white text-decoration-none">{profile.followingCount} <span className={"text-secondary"}>following</span></a>
          <a href={'#top'} className="text-white text-decoration-none ms-3">{profile.followersCount} <span className={"text-secondary"}>followers</span></a>
        </div>

      </div>
  );

};
export default ProfileScreen;